import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.outline.default};
  margin-bottom: -32px;
  color: white;
  padding: ${props => `${props.theme.spacing.sp16} 24px`};
  border-radius: ${props => props.theme.primitives.radius.radius6} ${props => props.theme.primitives.radius.radius6}
    ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0};
  z-index: 2;
`

export const SelectedViewSelectorText = styled.p`
  display: flex;
  align-items: center;
  color: ${props => (props.hasViewChanges ? props.theme.colors.accent.hover : 'white')};
  margin: 0;
  font-family: ${props => props.theme.texts.titleM.fontFamily};
  font-size: ${props => props.theme.texts.titleM.fontSize};
  gap: ${props => props.theme.spacing.sp8};
  text-align: left;

  ${props =>
    props.editing &&
    css`
      padding: 1px 6px;

      &:focus {
        outline: none;
      }
    `}

  ${props =>
    props.disabled &&
    css`
      color: ${props.theme.colors.disabled.content};
    `}
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
  color: ${props => props.theme.colors.text.default};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  margin-left: -25px;

  ${props =>
    props.isSelected &&
    css`
      font-weight: 600;
    `}

  ${props =>
    !props.isSelected &&
    css`
      svg {
        visibility: hidden;
      }
    `}
`

export const ActionMenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
  color: ${props => props.theme.colors.text.default};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
`

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp12};
`

export const HasChangesText = styled.p`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.accent.hover};
  font-size: ${props => props.theme.texts.bodySRegular};
  margin: 0;
`

export const EditActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
    font-size: ${props => props.theme.texts.bodySRegular};
    color: ${props => props.theme.colors.text.inverse};
  }
`

export const EditViewButton = styled.button`
  height: ${props => props.theme.size.M};
  width: ${props => props.theme.size.M};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${props =>
    props.success &&
    css`
      background-color: ${props.theme.colors.success.default};
    `}

  ${props =>
    props.danger &&
    css`
      background-color: ${props.theme.colors.danger.default};
    `}
`
